import React from "react";
import ZDropdown from "../ZDropdown";
import ZIcon from "@atoms/ZIcon";
import { EIcons } from "@atoms/ZIcon/interface";
import { EColors } from "@atoms/ZColors/interface";
import { IMoreButtonProps } from "./interface";
import ZTypography from "@atoms/ZTypography";

const ZMoreButton: React.FC<IMoreButtonProps> = ({
	menu,
	getPopupContainer,
	className = "",
	showMoreText = true,
	color = EColors.BLUE,
	colorVariant = 6,
	disabled = false,
	menuPlacement = "bottomRight"
}) => {
	return (
		<ZDropdown
			disabled={disabled}
			placement={menuPlacement}
			overlay={menu}
			trigger={["click"]}
			getPopupContainer={getPopupContainer}
		>
			<div
				className={`flex flex-col text-center ${
					disabled ? "cursor-not-allowed" : "cursor-pointer"
				} w-min m-auto ${className}`}
				onClick={event => {
					event.stopPropagation();
				}}
			>
				<ZIcon
					name={EIcons.MOREVERTICAL}
					size="sm"
					fill={true}
					color={color}
					colorVariant={colorVariant}
					className={`text-${color}-${colorVariant}`}
				/>
				{showMoreText && (
					<ZTypography.ZText
						level={0}
						color={color}
						colorVariant={colorVariant}
						className={"block mb-n1"}
					>
						More
					</ZTypography.ZText>
				)}
			</div>
		</ZDropdown>
	);
};

export default ZMoreButton;
